<template>
	<div class="home-body" v-loading="element_loading" element-loading-text="拼命加载中......"
		element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.8)">

		<div class="home-top">
			<div class="my-login">
				<div id="mylogin" class="my-login-img">

				</div>
				<!-- <div class="my-login-list" v-show="show_login">
					<div class="list-row" v-for="(item,index) in list_login" :key="index">
						<span class="list-num">第{{item.row_num}}名:</span><span class="list-user">{{item.u_name}}</span>					
					</div>
				</div> -->
			</div>
			<div class="my-over">
				<div class="my-over-title">昨日完成</div>
				<div v-show="is_admin=='1'">
					<preselect :inData="checkJson(sel_user)" @com-event="refresh_view_edit" />
				</div>
				<div>
					<table class="dataintable">

						<tr class="tab_header">
							<td>序号</td>
							<td class="long1 left">业务名称</td>
							<td>姓名</td>
							<td class="short0 ">统计日期</td>
							<td class="short0">完成数量</td>
							<td class="short0">更新日期</td>
						</tr>
						<tr v-for="(item, index) in list_one_day" :key="index">
							<td>{{ item.row_num }}</td>
							<td class="long1 left">{{ item.menu_name }}</td>
							<td>{{item.user_name}}</td>
							<td class="short0 ">{{item.over_date}}</td>
							<td class="short0">{{ item.over_num }}</td>
							<td class="short0">{{ item.sys_date }}</td>
						</tr>
					</table>
				</div>
			</div>
			<div class="my-over">
				<div class="my-go-title">快捷菜单</div>
				<div class="my-go-menu" v-for="(d, index) in list_quick" :key="index"
					@click="gochildren(d.id,d.two_value,d.two_name)">
					<span>
						{{ d.two_name }}
					</span>
				</div>
			</div>
			<!-- 还有一个预留位置 -->

			<div class="my-erweima">
				<div class="my-erweima-title">手机访问</div>
				<div id="qrcode" class="my-erweima-img" ref="qrcodeqf">

				</div>
				<div class="my-erweima-url">{{ydurl}}</div>
			</div>
		</div>
		<div class="home-bottom">
			<div class="row ">
				<label class="row-lalel">查询月份:</label>
				<el-date-picker v-model="sel_month.val" type="month" class="row-date" value-format="yyyy-MM"
					placeholder="选择日期" @change="init_user_month">
				</el-date-picker>
				<!-- <preselect :inData="checkJson(sel_menu)" @com-event="refresh_view_edit" /> -->
				<!-- <premonth :inData="checkJson(sel_month)" @com-event="refresh_view_edit" /> -->
				<!-- <div v-show="is_admin=='1'">
					<preselect :inData="checkJson(sel_user)" @com-event="refresh_view_edit" />
				</div> -->

				<ul class="row-list">
					<li v-bind:id="'busi_sum_' + d.row_num" v-for="(d, index) in list_menu" :key="index"
						@click="searchData(d)">
						<span>
							{{ d.menu_name }}
						</span>
					</li>
				</ul>
			</div>
			<div id="mymenuover" class="my-menu-over"></div>
		</div>

	</div>
</template>

<script>
	// import '@/assets/css/CSS.css';
	import {
		Message,
		GoUrl,
		GetRandom,
		checkStringByForm
	} from '@/utils/method.js';

	import {
		sysSelect
	} from '@/utils/systemSelect.js';

	import {
		BackSpecial
	} from "@/utils/localstore.js";

	import api from '@/utils/type.js'

	import {
		Sel_Mobile,
		Sel_page_and_length,
		Method_EasySelect
	} from '@/utils/loadhttpdata.js';

	import QRCode from 'qrcodejs2';
	// npm install qrcodejs2 --save

	// const url = require("@/assets/verify/images/1.jpg");
	export default {
		data() {
			return {
				element_loading: false,


				defaultimage: 'this.src="' + require('@/assets/img/icon_2.png') + '"',

				is_admin: '',
				list_login: [],
				list_one_day: [],
				list_quick: [],
				list_menu: [],

				show_login: false,

				sel_menu: {},
				sel_user: {},
				sel_month: {},

				activeName: '',
				ydurl: '',


			};
		},
		created: function() {

			// this.init_login();
			// this.init_sys();
			this.init_select();
			this.init_quick();
			this.init_erweima();

		},
		mounted: function() {
			const that = this;
			// 滚动事件 scroll
			// 变形事件 resize
			// window.addEventListener('resize', function() {
			//   var scrolltop = $(document).scrollTop();//获取当前窗口距离页面顶部高度
			//   if(scrolltop>0){
			//     that.init_login();
			//   }
			// }, false);
			this.$nextTick(function() {

				that.init_login();
				that.init_user();
				that.init_user_month();


			})
		},
		activated: function() {
			// console.log('keep-alive 组件激活时调用 激活');
			const that = this;
			this.$nextTick(function() {
				that.init_login();
				that.init_user();

			})
			// this.init_sys();
			// 
		},
		methods: {
			init_erweima: function() {
				this.ydurl = '';
				this.$post(
					api.http_method,
					Method_EasySelect('sys_login_init')
				).then(res => {
					res = JSON.parse(res);
					console.log(res);
					if (res.data.status == 1) {
						console.log(res);
						let turl = res.data.data[0].tydurl;
						this.ydurl = turl;
						this.build_erweima(turl);
					} else {
						this.$message({
							message: '没有查询到移动端访问地址,原因:' + res.data.msg,
							type: 'warning'
						});
					}

				});
			},
			build_erweima: function(url) {
				// var qr = new QRcode(document.getElementById('qrcode'));
				// //也可以在初始化QRCode对象，传入更多参数
				// var qr = new QRCode(document.getElementById("qrcode"),{
				// width: 128,
				// height: 128,
				// colorDark : "#000000",
				// colorLight : "#ffffff",
				// correctLevel : QRCode.CorrectLevel.H
				// });
				// //需要生成二维码的字符串
				// qr.makeCode("http://www.leixuesong.cn");
				//清除二维码
				// qr.clear();
				if (typeof(url) === 'undefined' || url == '') {
					return;
				}

				var qr = new QRCode(this.$refs.qrcodeqf, {
					text: url,
					width: 128,
					height: 128,
					colorDark: "#000000",
					colorLight: "#ffffff",
					correctLevel: QRCode.CorrectLevel.H
				});


			},
			checkJson: function(d) {
				let temp = '';
				temp = JSON.stringify(d)
				return temp;
			},
			refresh_view_edit: function(d) {
				// console.log(d);
				switch (d.key) {
					case 'menu_name':
						this.sel_menu.val = d.val;
						this.init_user_month();
						break;
					case 'user_name':
						this.sel_user.val = d.val;
						this.init_user();
						break;
					case 'sel_month':
						this.sel_month.val = d.val;
						this.init_user();
						this.init_user_month();
						break;
					default:
						break;
				}


			},
			look_news: function(url) {

				window.open(url);
			},
			goMyUrl: function(parm) {
				// console.log('跳转=' + parm);
				this.$router.push("/" + parm + "/" + GetRandom());
			},
			init_login: function() {
				// 基于准备好的dom，初始化echarts实例
				document.getElementById('mylogin').innerHTML = '';
				var myChart = this.$echarts.init(document.getElementById('mylogin'));

				this.element_loading = true;
				this.$post(
					api.http_method, Sel_Mobile('tu_login', 1, 100)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log(res);
					this.list_login = [];
					if (res.length > 0) {
						myChart.setOption({
							title: {
								text: '今天登录',
								textStyle: { //设置标题的文本样式
									color: '#000000'
								}
							},
							tooltip: {},
							series: [{
								name: '销量',
								type: 'pie',
								radius: '40%', // 饼图的半径，外半径为可视区尺寸（容器高宽中较小一项）的 55% 长度。
								roseType: 'angle',
								data: res[0]
							}],
							label: {
								normal: {
									textStyle: {
										color: 'rgba(255, 255, 255, 0.3)'
									}
								}
							},
							labelLine: {
								normal: {
									lineStyle: { //将标签的视觉引导线的颜色设为浅色
										color: 'rgba(255, 255, 255, 0.3)'
									}
								}
							},
							itemStyle: { //阴影的配置,还可以设置扇形的颜色，在normal中编辑color来设置，设置后的扇形颜色是一样的
								normal: {
									// 阴影的大小
									shadowBlur: 200,
									// 阴影颜色
									shadowColor: 'rgba(0, 0, 0, 0.5)'
								}
							}
						});

						if (res.length > 1) {
							this.list_login = res[1];
							if (this.list_login.length > 0) {
								this.show_login = true;
							} else {
								this.show_login = false
							}
						}


					}



				});
			},
			init_sys: function() {
				// 加载全局 系统设置变量
				this.element_loading = true;
				this.$post(
					api.http_method, Sel_Mobile('all_sys_set', 1, 100)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log('全局参数设置',res[0]);

					// console.log(this.GLOBAL);
					if (res.length > 0) {

						for (let i = 0; i < res[0].length; i++) {
							if (res[0][i].sys_no == 'sys_sel_car_set') {
								this.GLOBAL.ok_car_set = res[0][i];
							}
						}
					}
					// console.log(this.GLOBAL.ok_car_set);
				});

			},
			init_user: function() {
				this.is_admin = '0',
					this.list_one_day = [];
				this.element_loading = true;
				this.$post(
					api.http_method, Sel_Mobile('all_user_over', 1, 10, '', '', this.sel_user.val)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					this.is_admin = res[0][0].is_admin;

					if (res[0][0].flag == '0') {
						this.$message({
							message: res[0][0].err,
							type: 'warning'
						});
						return;
					}

					if (res[0][0].flag == '1') {
						this.list_one_day = res[1];
					}

					// console.log(this.GLOBAL.ok_car_set);
				});
			},
			init_quick: function() {

				this.list_quick = [];
				this.element_loading = true;
				this.$post(
					api.http_method, Sel_page_and_length('exp_my_menu_quick', 1, 10)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);

					if (res[0][0].flag == '0') {
						this.$message({
							message: res[0][0].err,
							type: 'warning'
						});
						return;
					}

					if (res[0][0].flag == '1') {
						this.list_quick = res[1];
					}

					// console.log(this.list_quick);
				});
			},
			init_user_month: function() {


				this.element_loading = true;

				let myChart_month = this.$echarts.init(document.getElementById('mymenuover'));



				this.$post(
					api.http_method, Sel_Mobile('all_user_over_month', 1, 30, this.sel_menu.val, this.sel_month
						.val, this.sel_user.val)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);
					// console.log('加载月总结', res[0]);

					if (res[0][0].flag == '0') {
						this.$message({
							message: res[0][0].err,
							type: 'warning'
						});

						return;
					}

					if (res[0][0].flag == '1') {
						// console.log('加载统计结果', res[1]);
						let t = res[1];

						let option = {};

						let menu_name = [],
							menu_date = [],
							menu_list = [];
						for (let i = 0; i < t.length; i++) {
							let res_name = menu_name.find(ele => ele === t[i].menu_name);
							if (!res_name) {
								menu_name.push(t[i].menu_name);
							}
							let res_date = menu_date.find(ele => ele === t[i].over_date);
							if (!res_date) {
								menu_date.push(t[i].over_date);
							}
							let o = {};

							o.name = t[i].menu_name;
							o.type = 'line';
							o.stack = 'Total';
							o.data = [t[i].over_num];

							let is_exists = '0';
							// //添加第一个
							if (menu_list.length > 0) {
								for (let j = 0; j < menu_list.length; j++) {
									if (menu_list[j].name == t[i].menu_name) {
										is_exists = '1';
									}
								}
								// 添加第一个 元素
								if (is_exists == '0') {
									menu_list.push(o);
								}

								if (is_exists == '1') {
									for (let j = 0; j < menu_list.length; j++) {
										if (menu_list[j].name == t[i].menu_name) {
											menu_list[j].data.push(t[i].over_num);
										}
									}
								}
							} else {
								menu_list.push(o);
								// console.log('当前数据', menu_list);
							}
						}
						// console.log('名称', menu_name);
						// console.log('日期', menu_date);
						// console.log('数据', menu_list);


						option = {
							title: {
								text: '按月统计'
							},
							tooltip: {
								trigger: 'axis'
							},
							legend: {
								data: menu_name
							},
							grid: {
								left: '3%',
								right: '4%',
								bottom: '3%',
								containLabel: true
							},
							toolbox: {
								feature: {
									saveAsImage: {}
								}
							},
							xAxis: {
								type: 'category',
								boundaryGap: false,
								data: menu_date
							},
							yAxis: {
								type: 'value'
							},
							series: menu_list
						};

						myChart_month.setOption(option, true); //重新加载



					}

					// console.log(this.GLOBAL.ok_car_set);
				});

			},
			init_select: function() {
				// console.log('加载筛选')

				this.sel_menu = {
					"name": "业务名称",
					"val": "",
					"key": "menu_name",
					"type": "select",
					"sel_action": "_base_busi_name",
					"sel_name": "",
					"class": "long1",
					"p": "0",
					"w": "0",
					"r": "0"
				};

				this.sel_user = {
					"name": "姓名",
					"val": "",
					"key": "user_name",
					"type": "select",
					"sel_action": "data_alluser",
					"sel_name": "",
					"class": "long1",
					"p": "0",
					"w": "0",
					"r": "0"
				};

				this.sel_month = {
					"name": "月份",
					"val": "",
					"key": "sel_month",
					"type": "month",
					"class": "long1",
					"p": "0",
					"w": "0",
					"r": "0"
				};

				this.list_menu = [];
				this.element_loading = true;
				this.$post(
					api.http_method, Sel_page_and_length('exp_my_menu_sum', 1, 10)
				).then(res => {
					this.element_loading = false;
					res = JSON.parse(res);

					if (res[0][0].flag == '0') {
						this.$message({
							message: res[0][0].err,
							type: 'warning'
						});
						return;
					}

					if (res[0][0].flag == '1') {
						this.list_menu = res[1];
					}

					// console.log(this.list_menu);
				});
			},
			searchData: function(item) {
				console.log(item)

				for (var j = 0; j < this.list_menu.length; j++) {
					if (this.list_menu[j].row_num == item.row_num) {
						// console.log(this.menu[i].children[j]);
						document.getElementById('busi_sum_' + this.list_menu[j].row_num).style.background = '#a3d5ff';
					} else {
						document.getElementById('busi_sum_' + this.list_menu[j].row_num).style.background =
							'white';
					}
				}
				this.sel_menu.val = item.id;
				this.init_user_month();
			},
			gochildren: function(tid, path, name) {
				// console.log('菜单id=' + tid + ' 路径=' + path);
				// 颜色保留

				let r = (Math.random() * 10000 + '').substring(0, 4);
				let parm = {
					"check_key": '',
					"random": r
				};
				GoUrl(this, path, parm);
				// 传参 用来刷新 顶部 导航 跳页太多过不去。。。
				// let menu_click = [];
				// var o = {};
				// o.id = tid;
				// o.name = name;
				// o.path = path;
				// o.parm = parm;
				// o.flag = '1';
				// menu_click.push(o);
				// console.log(this);
				// this.$emit("my-menu-left", menu_click);
			}

		}
	};
</script>
<style scoped="scoped">
	.home-body {
		height: auto;
		width: 100%;
	}

	.home-top {
		display: flex;
		margin-top: 6px;
		justify-content: flex-start;
	}

	.my-login {
		height: 360px;
		border: 1px solid #bdbdbd;
		border-radius: 6px;
		display: flex;
		/* width: 500px; */
		width: auto;
	}

	.my-login-img {
		display: inline-flex;
		width: 360px;
		height: 360px;
	}

	/* .my-login-list {
		display: inline-flex;
		height: 360px;
		width: 128px;
		flex-direction: column;
		justify-content: flex-start;
		align-items: flex-start;
		padding-right: 6px;
		padding-top: 85px;
	} */

	.list-row {
		display: flex;
		flex-direction: row;
	}

	.list-num {
		display: inline-flex;
		min-width: 48px;

		justify-content: flex-end;
	}

	.list-user {
		display: inline-flex;

		max-width: 80px;
		word-break: keep-all;
		overflow: hidden;

		text-overflow: ellipsis;
		content: "...";
	}

	.my-over {
		display: flex;
		height: 360px;
		flex-direction: column;
		align-items: flex-start;
		padding-left: 16px;
		padding-right: 16px;
		border: 1px solid #bdbdbd;
		margin-left: 6px;
		border-radius: 6px;
	}

	.my-over-title {
		font-size: 18px;
		color: #000000;
		font-weight: bold;
	}

	.my-go {
		display: flex;
		height: 360px;
		flex-direction: column;
		align-items: flex-start;
		padding-left: 16px;
		padding-right: 16px;
		border: 1px solid #bdbdbd;
		border-radius: 6px;
		margin-left: 6px;
	}

	.my-go-title {
		font-size: 18px;
		color: #000000;
		font-weight: bold;
		margin-bottom: 8px;

	}

	.my-go-menu {
		margin-top: 2px;
		font-size: 14px;

		width: 100%;
		min-width: 120px;
	}

	.my-go-menu:hover {


		cursor: pointer;
		font-weight: bold;
	}

	.home-bottom {
		border: 1px solid #bdbdbd;
		border-radius: 6px;
		padding: 6px;
		margin-top: 6px;

		display: flex;
		justify-content: flex-start;
	}

	.home-bottom .row {
		display: inline-flex;
		flex-direction: column;
	}

	.row-lalel {
		display: flex;
		margin-bottom: 2px;
		width: 100%;
		justify-content: flex-end;
	}

	.row-date {
		display: flex;
		width: 120px;
		margin-bottom: 6px;
	}

	.row-list {
		height: auto;
		list-style-type: none;
		padding: 2px;
	}

	.row-list>li {
		font-size: 16px;
		padding-right: 5px;
		padding-left: 15px;
		padding-top: 5px;
		padding-bottom: 5px;
		width: 100%;
		height: 24px;
		line-height: 24px;
		background: white;
		border-radius: 5px;
	}

	.row-list>li:hover {
		cursor: pointer;
		font-size: 16px;
		font-weight: bold;
		background-color: #e3e3e3;
	}


	.tab_header td {
		/* 纵向渐变 */
		/* Safari 5.1 - 6.0 */
		background: -webkit-linear-gradient(#3da5d9, #a2d2ff);
		/* Opera 11.1 - 12.0 */
		background: -o-linear-gradient(#3da5d9, #a2d2ff);
		/* Firefox 3.6 - 15 */
		background: -moz-linear-gradient(#3da5d9, #a2d2ff);
		/* 标准的语法（必须放在最后） */
		background: linear-gradient(#3da5d9, #a2d2ff);
		text-align: center;
		color: #000000;
		font-size: 14px;
		font-weight: 400;
	}


	.my-menu-over {
		display: inline-flex;

		width: 72vw;
		min-width: 600px;
		min-height: calc(100vh - 360px);
	}

	.my-erweima {
		display: flex;
		height: 360px;
		flex-direction: column;
		align-items: flex-start;
		padding-left: 16px;
		padding-right: 16px;
		border: 1px solid #bdbdbd;
		margin-left: 6px;
		border-radius: 6px;

	}

	.my-erweima-title {
		font-size: 18px;
		color: #000000;
		font-weight: bold;
		margin-bottom: 8px;
	}
	
	.my-erweima-url{
		font-size: 12px;
		color: #000000;
		font-weight: bold;
		margin-bottom: 8px;
	}
</style>